/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { memo } from 'react';

import { useLocation } from 'js/lib/useRouter';

import { Typography2 } from '@coursera/cds-core';
import { CertificateIcon, DegreeIcon } from '@coursera/cds-icons';

import { carouselExperimentLocations } from 'bundles/collections-carousel/constants';

import _t from 'i18n!nls/product-card';

const styles = {
  reviews: css`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  `,
  reviewItem: css`
    margin-right: 4px;
  `,
  reviewsBlue: () => css`
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    && {
      color: var(--cds-color-blue-800);
    }
  `,
  reviewItemBlue: () => css`
    margin-right: 4px;

    && {
      color: var(--cds-color-blue-800);
    }
  `,
};

const ProductCardDegreeOrCredit = ({
  isDegree,
  showCreditOffered,
}: {
  isDegree: boolean;
  showCreditOffered: boolean;
}) => {
  const location = useLocation();

  if (!isDegree && !showCreditOffered) {
    return null;
  }

  const textShouldBeBlue = carouselExperimentLocations.includes(location.pathname);

  return (
    <div css={textShouldBeBlue ? styles.reviewsBlue : styles.reviews}>
      {isDegree ? (
        <DegreeIcon css={textShouldBeBlue ? styles.reviewItemBlue : styles.reviewItem} color="support" />
      ) : (
        <CertificateIcon css={textShouldBeBlue ? styles.reviewItemBlue : styles.reviewItem} color="support" />
      )}
      <Typography2
        component="p"
        variant="bodySecondary"
        color="supportText"
        css={textShouldBeBlue ? styles.reviewItemBlue : styles.reviewItem}
      >
        {isDegree ? _t('Earn a degree') : _t('Credit offered')}
      </Typography2>
    </div>
  );
};

export default memo(ProductCardDegreeOrCredit);
